import React, { Fragment } from 'react';
import { motion } from 'framer-motion';
import { useLanguage, Language } from '../context/LanguageContext';
export const LanguageSelector = () => {
  const {
    language,
    setLanguage
  } = useLanguage();
  const languages: {
    code: Language;
    label: string;
  }[] = [{
    code: 'en',
    label: 'English'
  }, {
    code: 'pa',
    label: 'ਪੰਜਾਬੀ'
  }, {
    code: 'fr',
    label: 'Français'
  }];
  return <div className="flex items-center gap-1" data-id="element-635">
      {languages.map((lang, index) => <Fragment key={lang.code} data-id="element-636">
          <motion.button onClick={() => setLanguage(lang.code)} className={`px-4 py-2 text-sm font-light tracking-wider transition-colors ${language === lang.code ? 'text-amber-400' : 'text-white/60 hover:text-white/80'}`} whileHover={{
        scale: 1.05
      }} whileTap={{
        scale: 0.95
      }} data-id="element-637">
            {lang.label}
          </motion.button>
          {index < languages.length - 1 && <div className="w-px h-4 bg-white/20" data-id="element-638"></div>}
        </Fragment>)}
    </div>;
};